import type {
  ProductEventMap,
  TelemetryPort,
  TelemetryProperties,
} from "./contracts.js";

export class NoopTelemetry implements TelemetryPort {
  public readonly enabled = false;

  public setConsent(enabled: boolean): void {
    void enabled;
  }

  public track<EventName extends keyof ProductEventMap>(
    _name: EventName,
    _properties: ProductEventMap[EventName],
  ): void {
    void _name;
    void _properties;
  }

  public captureError(error: unknown, metadata?: TelemetryProperties): void {
    void error;
    void metadata;
  }

  public async flush(): Promise<void> {}

  public async shutdown(): Promise<void> {}
}
